import { render, staticRenderFns } from "./AddUpdateAssetFromTemplate.vue?vue&type=template&id=36cf3f5f"
import script from "./AddUpdateAssetFromTemplate.vue?vue&type=script&lang=js"
export * from "./AddUpdateAssetFromTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateAssetFromTemplate.vue?vue&type=style&index=0&id=36cf3f5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports